import axios from 'axios';

const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;

// Interface para os dados do evento, se precisarmos tipar
export interface PersonFeedEventData {
  personId: string;
  eventDate: string;
  eventTypes: string[];
  // Adicionar outros campos conforme necessário
  [key: string]: any; 
}

const personFeedService = {
  /**
   * Cria um novo evento no feed.
   * @param formData - O objeto FormData contendo os dados do evento e os arquivos.
   */
  async createEvent(formData: FormData): Promise<any> {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${API_BASE_URL}/person-feed`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data', // Essencial para envio de arquivos
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao criar evento no feed:', error);
      // Lançar o erro para que o componente possa tratá-lo
      throw error.response?.data?.message || 'Não foi possível salvar o evento.';
    }
  },

  /**
   * Busca os eventos do feed para uma pessoa específica.
   * @param personId - O ID da pessoa.
   */
  async getFeedForPerson(personId: number): Promise<any[]> {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_BASE_URL}/person-feed/${personId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar feed para a pessoa ${personId}:`, error);
      throw error.response?.data?.message || 'Não foi possível buscar a timeline.';
    }
  },

  /**
   * Busca um evento específico pelo ID.
   * @param eventId - O ID do evento.
   */
  async getEventById(eventId: string): Promise<any> {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_BASE_URL}/person-feed/event/${eventId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar o evento ${eventId}:`, error);
      throw error.response?.data?.message || 'Não foi possível carregar os detalhes do evento.';
    }
  },

  /**
   * Deleta um evento do feed.
   * @param eventId - O ID do evento.
   */
  async deleteEvent(eventId: number): Promise<void> {
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${API_BASE_URL}/person-feed/${eventId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error(`Erro ao deletar evento ${eventId}:`, error);
      throw error.response?.data?.message || 'Não foi possível deletar o evento.';
    }
  },
};

export default personFeedService;
